import React from 'react';
import { Colors } from '../../themes';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SvgIcon from '../../icons/SvgIcon';
import Button from '@material-ui/core/Button';
import Select from '../common/Select';

const useStyles = makeStyles((theme) => {
  return {
    editSettingsContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowWrap: 'break-word',
      width: 300,
      minHeight: 400,
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      marginRight: -12,
    },
    informationSection: {
      marginTop: theme.spacing(4),
    },
    footerButtonsContainer: {
      minHeight: 80,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      borderRadius: '4px 4px 0 0',
      padding: theme.spacing(4),
      marginTop: 20,
    },
    button: {
      fontSize: 14,
      color: Colors.black,
      border: `1px solid ${Colors.disabledGrey}`,
      '&:hover': {
        background: Colors.disabledGrey,
        color: Colors.white,
      },
    },
    addAccessLevelsButton: {
      marginRight: 'auto',
      marginTop: 20,
    },
    errorButton: {
      color: Colors.errorRed,
      borderColor: Colors.errorRed,
      '&:hover': {
        borderColor: Colors.disabledGrey,
      },
    },
    errorText: {
      color: Colors.errorRed,
      fontSize: '0.75rem',
      marginTop: 4,
    },
    saveButton: {
      marginLeft: theme.spacing(1),
      fontSize: 14,
      color: Colors.white,
      background: Colors.blue,
      border: 'none',
      '&:hover': {
        background: Colors.lightBlue,
      },
    },
    datePicker: {
      marginTop: 16,
    },
    switch: {
      marginTop: 34,
      marginLeft: 15,
      marginRight: 'auto',
    },
  };
});

const EditSettingsModal = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onClose, onClickSave } = props;
  const handleSubmit = (event) => {
    event.preventDefault();
    onClickSave();
  };
  return (
    <div className={classes.editSettingsContainer}>
      <form
        id="personForm"
        className={classes.formContainer}
        noValidate
        onSubmit={handleSubmit}
        autoComplete="off"
        // onKeyPress={(event) => onKeyPress(event)}
      >
        <div className={classes.header}>
          <Typography variant="h2" id="modal-title">
            {'Edit controller settings'}
          </Typography>
          <IconButton className={classes.closeButton} key="close" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        </div>
        <div className={classes.informationSection}>
          {/* select ReaderDirection */}
          <Select
            selectData={props.readerDirectionSelectData}
            selectLabel={props.readerDirectionSelectLabel}
            selectValue={props.readerDirectionSelectValue}
            onSelect={props.readerDirectionOnSelect}
            noEntry={props.noEntry}
            selectWidth={props.selectWidth}
            lightTheme={props.lightTheme}
            formStyle={props.formStyle}
          />
          {/* select ReaderBitCount */}
          <Select
            selectData={props.readerBitCountSelectData}
            selectLabel={props.readerBitCountSelectLabel}
            selectValue={props.readerBitCountSelectValue}
            onSelect={props.readerBitCountOnSelect}
            noEntry={props.noEntry}
            selectWidth={props.selectWidth}
            lightTheme={props.lightTheme}
            formStyle={props.formStyle}
          />
          {/* select ReaderReadType */}
          <Select
            selectData={props.readerReadTypeSelectData}
            selectLabel={props.readerReadTypeSelectLabel}
            selectValue={props.readerReadTypeSelectValue}
            onSelect={props.readerReadTypeOnSelect}
            noEntry={props.noEntry}
            selectWidth={props.selectWidth}
            lightTheme={props.lightTheme}
            formStyle={props.formStyle}
          />
          {/* select readerRevert */}
          <Select
            selectData={props.readerRevertSelectData}
            selectLabel={props.readerRevertSelectLabel}
            selectValue={props.readerRevertSelectValue}
            onSelect={props.readerRevertOnSelect}
            noEntry={props.noEntry}
            selectWidth={props.selectWidth}
            lightTheme={props.lightTheme}
            formStyle={props.formStyle}
          />
        </div>
        <div className={classes.footerButtonsContainer}>
          <Button type="button" variant="outlined" className={classes.button} onClick={props.cancelEditSettings}>
            {t('Global_cancel')}
          </Button>
          <Button
            type="submit"
            variant="contained"
            className={classes.saveButton}
            onClick={onClickSave}
            endIcon={<SvgIcon icon="Save" width={20} color={Colors.white} />}
          >
            {t('Global_save')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditSettingsModal;
